<ng-container *ngIf="showContent$ | async">
  <ng-content></ng-content>
</ng-container>
